
























































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditTestQuestionUs from "./edit-testQuestionUs.vue";
import SisterQuestionUs from "./sister-QuestionUs.vue";
import ShowQuestionOfPapers from "./show-questionOfPapers.vue";

class PageTestQuestionRequest extends PageRequest {
  keyword: string;
  ExternalType: number = 0;
  GradeType: number = 1;
  classTypeId: number = 11;
  multiTypeName: string = "章节";
  parentId?: number;
  parentName: string = "上级分类";
  sectionId?: number;
  questionType: number = 0;
  ScreenType: number = 0;
  //isAudit: string = null;
  QuestionAuditFlow: string = null;
}

@Component({
  components: { EditTestQuestionUs, SisterQuestionUs, ShowQuestionOfPapers },
})
export default class TestQuestions extends AbpBase {
  pagerequest: PageTestQuestionRequest = new PageTestQuestionRequest();
  editModalShow: Boolean = false;
  sisterModalShow: Boolean = false;
  tesPaperModalShow: Boolean = false;
  loading: Boolean = false;
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  backshow: Boolean = false;

  valueArray: any = [];
  IsAuditList: any = [
    { value: "null", label: "全部" },
    { value: "1", label: "通过审核" },
    { value: "0", label: "未通过审核" },
    { value: "2", label: "申请修改" },
  ];
  IsUserList: any = [
    { value: 0, label: "全部试题" },
    { value: 1, label: "我的试题" },
  ];
  newtabdata: any = [
    { value: 0, label: "判断题" },
    { value: 1, label: "单选题" },
    { value: 2, label: "多选题" },
    { value: 3, label: "填空题" },
    { value: 4, label: "计算题" },
    { value: 8, label: "解答题" },
    { value: 9, label: "作文题" },
    { value: 10, label: "探究题" },
    { value: 11, label: "材料题" },
    { value: 12, label: "实践题" },
    { value: 7, label: "选考单选" },
    { value: 5, label: "选考多选" },
    { value: 6, label: "选考计算" },
  ];

  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  }
  beforeDestroy() {
    window.removeEventListener("scroll", this.showbtn, true);
  }
  showbtn() {
    let scrollTop = (this.$refs["obtain"] as any).getBoundingClientRect().top;
    scrollTop < 210 ? (this.backshow = true) : (this.backshow = false);
  }
  backtop() {
    let _this = this;
    (_this.$refs["obtain"] as any).scrollIntoView(true);
    _this.backshow = false;
  }
  toTestPaper(id) {
    this.$store.state.testQuestion.editTestQuestion.id = id;
    this.tesPaperModalShow = true;
  }
  UsdegreeDifficulty(value) {
    if (value == 1) {
      return "(A层次)";
    } else if (value == 2) {
      return "(B层次)";
    } else {
      return "(C层次)";
    }
  }
  sisterQuestion(item) {
    this.$store.commit("testQuestion/sisterInfo", item);
    this.$store.state.testQuestion.sisterInfoTestQuestion.sisterId = item.id;
    this.sisterModalShow = true;
  }
  searchGetpage() {
    if (this.pagerequest.QuestionAuditFlow == "null") {
      this.pagerequest.QuestionAuditFlow = "";
    }
    this.$store.state.testQuestion.currentPage = 1;
    this.getpage();
  }
  async stateSwitching(id) {
    await this.$store.dispatch({
      type: "testQuestion/showStateSwitching",
      data: { id: id, questionType: this.pagerequest.questionType },
    });
    this.getpage();
  }
  async auditQuestion(id) {
    await this.$store.dispatch({
      type: "testQuestion/auditTestQuestionFlow",
      data: {
        id: id,
        questionAuditFlow: 1,
        questionType: this.pagerequest.questionType,
      },
    });
    this.getpage();
  }

  async resetupdate(id) {
    await this.$store.dispatch({
      type: "testQuestion/auditTestQuestionFlow",
      data: {
        id: id,
        questionAuditFlow: 2,
        questionType: this.pagerequest.questionType,
      },
    });
    this.getpage();
  }

  async doupdate(id) {
    await this.$store.dispatch({
      type: "testQuestion/auditTestQuestionFlow",
      data: {
        id: id,
        questionAuditFlow: 0,
        questionType: this.pagerequest.questionType,
      },
    });
    this.getpage();
  }

  async updateQuestion(row) {
    this.$store.commit("testQuestion/edit", row);
    this.editModalShow = true;
  }
  async deleteQuestion(id) {
    this.$Modal.confirm({
      title: "系统提示",
      content: "你确定要删除本试题？",
      okText: "是",
      cancelText: "否",
      onOk: async () => {
        await this.$store.dispatch({
          type: "testQuestion/delete",
          data: { id: id, questionType: this.pagerequest.questionType },
        });
        await this.getpage();
      },
    });
  }
  questionTypeChange(value) {
    this.pagerequest.questionType = value;
    this.$store.state.testQuestion.currentPage = 1;
    this.getpage();
  }

  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.sectionId = selectedData[selectedData.length - 1].value;
      this.pagerequest.parentName = selectedData[selectedData.length - 1].label;
    } else {
      this.pagerequest.sectionId = null;
    }
    this.getpage();
  }
  handleRefresh() {
    this.loadCascaders();
    this.getpage();
  }
  get list() {
    return this.$store.state.testQuestion.list;
  }
  //get loading() {
  //  return this.$store.state.testQuestion.loading;
  // }
  create() {
    this.editModalShow = true;
    this.$store.state.testQuestion.editTestQuestion.classTypeId = this.pagerequest.classTypeId;
    this.$store.state.testQuestion.editTestQuestion.multiTypeName = this.pagerequest.multiTypeName;
    this.$store.state.testQuestion.editTestQuestion.parentId = this.pagerequest.parentId;
    this.$store.state.testQuestion.editTestQuestion.parentName = this.pagerequest.parentName;
  }
  multiTypeChange() {}
  selectChange(item) {
    this.pagerequest.classTypeId = item.id;
    this.pagerequest.multiTypeName = item.text;
    this.valueArray = [];
    this.pagerequest.parentId = null;
    this.loadCascaders();
    this.searchGetpage();
  }

  pageChange(page: number) {
    this.$store.commit("testQuestion/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("testQuestion/setPageSize", pagesize);
    this.getpage();
  }
  async loadCascaders() {
    let _this = this;
    _this.loading = true;
    await this.$store
      .dispatch({
        type: "testQuestion/getCascader",
        data: { classTypeId: this.pagerequest.classTypeId },
      })
      .then((result) => {
        this.data = this.$store.state.testQuestion.cascaders.items;
        if (sessionStorage.getItem("isGeneral") == "true") {
          if (this.data.length) {
            this.pagerequest.sectionId = this.data[0].value;
            this.pagerequest.parentName = this.data[0].label;
            this.valueArray.push(this.data[0].value);
          }
        }
        this.getpage();
      });
  }
  async getpage() {
    let _this = this;
    if (!_this.loading) {
      _this.loading = true;
    }
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store
      .dispatch({
        type: "testQuestion/getAll",
        data: this.pagerequest,
      })
      .then((res) => {
        this.loading = false;
      })
      .catch((err) => {});
  }
  get isGeneral() {
    return sessionStorage.getItem("isGeneral") == "true" ? 1 : 0;
  }
  get userId() {
    return sessionStorage.getItem("userId");
  }

  get pageSize() {
    return this.$store.state.testQuestion.pageSize;
  }
  get totalCount() {
    return this.$store.state.testQuestion.totalCount;
  }
  get currentPage() {
    return this.$store.state.testQuestion.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
  async created() {
    this.loadCascaders();
  }
}
